"use strict";
/**
 * @file Created on 29/08/2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var DataDictionaryError_1 = require("../../core/model/data-dictionary/DataDictionaryError");

var utils_1 = require("../../core/utils");

var ProductSuppliersConverter_1 = require("../../supply/conversions/ProductSuppliersConverter");

var ProductSuppliersGroupConverter_1 = require("../../supply/conversions/ProductSuppliersGroupConverter");

var FindWindowProductsDTO_1 = require("../model/FindWindowProductsDTO");

var FindWindowProductsDTOConverter_1 = require("./FindWindowProductsDTOConverter");

var ProductConverter_1 = require("./ProductConverter");
/**
 * WindowCopyResultDTOConverterImpl
 *
 * @author Tomáš Leity
 */


var FindWindowProductsDTOConverterImpl =
/*#__PURE__*/
function (_FindWindowProductsDT) {
  _inherits(FindWindowProductsDTOConverterImpl, _FindWindowProductsDT);

  function FindWindowProductsDTOConverterImpl(productConverter, productSuppliersConverter, productSuppliersGroupConverter) {
    var _this;

    _classCallCheck(this, FindWindowProductsDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FindWindowProductsDTOConverterImpl).call(this));
    _this.productConverter = productConverter;
    _this.productSuppliersConverter = productSuppliersConverter;
    _this.productSuppliersGroupConverter = productSuppliersGroupConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FindWindowProductsDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new FindWindowProductsDTO_1.FindWindowProductsDTO(conversions.asObjectList(source, 'products', function (product) {
        return _this2.productConverter.toObject(product, conversions);
      }), conversions.asObjectList(source, 'productIds', function (id) {
        if (utils_1.Utils.isValueMissing(id)) {
          throw new DataDictionaryError_1.DataDictionaryError("Product id cannot be empty!");
        }

        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'categoryIds', function (id) {
        if (utils_1.Utils.isValueMissing(id)) {
          throw new DataDictionaryError_1.DataDictionaryError("Category id cannot be empty!");
        }

        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'suppliers', function (productSuppliers) {
        return _this2.productSuppliersConverter.toObject(productSuppliers, conversions);
      }), conversions.asObjectList(source, 'supplierIds', function (id) {
        if (utils_1.Utils.isValueMissing(id)) {
          throw new DataDictionaryError_1.DataDictionaryError("Supplier id cannot be empty!");
        }

        return conversions.toClassReferenceId(id);
      }), conversions.asObjectList(source, 'supplierGroups', function (productSuppliers) {
        return _this2.productSuppliersGroupConverter.toObject(productSuppliers, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        products: conversions.asObjectArray(source, 'products', function (product) {
          return _this3.productConverter.toDocument(product, conversions);
        }),
        productIds: conversions.asObjectArray(source, 'productIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        categoryIds: conversions.asObjectArray(source, 'categoryIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        suppliers: conversions.asObjectArray(source, 'suppliers', function (productSuppliers) {
          return _this3.productSuppliersConverter.toDocument(productSuppliers, conversions);
        }),
        supplierIds: conversions.asObjectArray(source, 'supplierIds', function (id) {
          return conversions.toDocumentReferenceId(id);
        }),
        supplierGroups: conversions.asObjectArray(source, 'supplierGroups', function (productSuppliersGroup) {
          return _this3.productSuppliersGroupConverter.toDocument(productSuppliersGroup, conversions);
        })
      });
      return result;
    }
  }]);

  return FindWindowProductsDTOConverterImpl;
}(FindWindowProductsDTOConverter_1.FindWindowProductsDTOConverter);

FindWindowProductsDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ProductConverter_1.ProductConverter, ProductSuppliersConverter_1.ProductSuppliersConverter, ProductSuppliersGroupConverter_1.ProductSuppliersGroupConverter])], FindWindowProductsDTOConverterImpl);
exports.FindWindowProductsDTOConverterImpl = FindWindowProductsDTOConverterImpl;